// Client-side public surface: what other modules may use.

import { lazyView } from "@/platform/client";

export { FeedSettingsCard } from "./ui/FeedSettingsCard.js";
export const FeedsPage = lazyView(() => import("./ui/FeedsPage.js").then((m) => m.FeedsPage));
export { feedNotifications } from "./ui/notifications.js";
export { useFeeds } from "./ui/queries.js";
